interface FormActionsProps {
  onCancel: () => void;
  onContinue: () => void;
  currentStep: number;
  isAgent: boolean;
}

export const FormActions = ({
  onCancel,
  onContinue,
  currentStep,
  isAgent,
}: FormActionsProps) => {
  const getButtonLabel = () => {
    if (currentStep === 1) return "Continue";
    if (currentStep === 2 && !isAgent) return "Create User";
    if (currentStep === 2 && isAgent) return "Continue";
    if (currentStep === 3) return "Create User";
    return "Continue";
  };
  return (
    <div className="absolute bottom-0 w-full bg-pure-white dark:bg-pure-white-dk backdrop-blur-[20px] py-[18px] px-3">
      <div className="flex items-center justify-end gap-2">
        <button
          type="button"
          className="border border-verba-indigo dark:border-verba-indigo-dk text-heading-text dark:text-heading-text-dk text-center text-md font-semibold rounded-lg py-[3px] w-[100px]"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="border border-verba-indigo dark:border-verba-indigo-dk bg-verba-indigo dark:bg-verba-indigo-dk text-pure-white dark:text-pure-white-dk hover:border-verba-blue dark:hover:border-verba-blue-dk hover:bg-verba-blue dark:hover:bg-verba-blue-dk text-center hover:text-fixed-white hover:dark:text-fixed-black text-md font-semibold rounded-lg py-[3px] w-[105px]"
          onClick={onContinue}
        >
          {getButtonLabel()}
        </button>
      </div>
    </div>
  );
};
